import api from "./api";

export const getReportsCourses = (year, quarter) => {
  return api.get(`api/report/courses/${year}/${quarter}`);
};

export const getAllReportsCourses = (year) => {
  return api.get(`api/report/courses-all/${year}`);
};
